import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class LoreCorrectionService {
  private http = inject(HttpClient);

  approve(storyId: number, proposalId: string, loreMessageId: number) {
    return this.http.post(
      `${environment.masterServerUrl}/api/${storyId}/lore-corrections/${proposalId}/approve`,
      { loreMessageId },
    );
  }

  reject(storyId: number, proposalId: string, loreMessageId: number) {
    return this.http.post(
      `${environment.masterServerUrl}/api/${storyId}/lore-corrections/${proposalId}/reject`,
      { loreMessageId },
    );
  }
}
